import { ErrorHandler } from "@angular/core";

export class GlobalErrorHandler implements ErrorHandler {
  handleError(error: any): void {
    // do something with the exception
    console.error('Erro Global App: ', error);
  }
}
